import React, { useEffect, useRef, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import Loader from '../Loader';
import * as MinistryReportApi from '../../api/MinistryReportApi';
import { toast } from 'react-toastify';
import IncidentListingModal from './IncidentListingModal';

const MinistryTypeOfIssueDonut = ({
  data,
  height = 280,
  width = 450,
  isLoading,
  selectedDatee,
  selectedShift,
}) => {
  const categoryColors = {
    major: 'red',
    minor: 'blue',
    unspecified: 'gray', // Default color for Unspecified type
  };
  const DEFAULT_INCIDENT_DETAILS_MODAL = {
    center_id: null,
    show: false,
    title: 'Incident Details',
  };
  const [showIncidentDetailsModal, setShowIncidentDetailsModal] = useState(
    DEFAULT_INCIDENT_DETAILS_MODAL
  );

  const [selectedType, setSelectedType] = useState(null);

  const dataRef = useRef(data);

  useEffect(() => {
    dataRef.current = data;
  }, [data]);

  const [modalData, setModalData] = useState([]);

  const [filter, setFilter] = useState({
    type: '',
    date: '',
    shift: '',
  });

  const fetchModalData = async () => {
    const response = await MinistryReportApi.getMajorMinorIncidents(filter);

    if (response?.success) {
      setModalData(response?.data);
    } else {
      toast.error(`Error fetching stage incidents:  ${response?.message}`);
    }
  };

  useEffect(() => {
    if (filter.type) {
      fetchModalData();
    }
  }, [filter.type]);

  useEffect(() => {
    setFilter((prev) => ({
      stage: '',
      date: selectedDatee,
      shift: selectedShift,
    }));
  }, [selectedDatee, selectedShift]);

  const [chartData, setChartData] = useState({
    series: [0],
    options: {
      chart: {
        type: 'donut',
        events: {
          dataPointSelection: (event, chartContext, config) => {
            const clickedStage = dataRef.current[config?.dataPointIndex].type;
            setSelectedType(clickedStage);

            setFilter((prev) => ({
              ...prev,
              type: clickedStage,
            }));
            setShowIncidentDetailsModal((prev) => ({ ...prev, show: true }));
          },
        },
      },
      legend: {
        show: true,
        position: 'bottom', // Legend at bottom
        floating: false,
        itemMargin: {
          vertical: 10,
        },
      },
      labels: [], // Initialize labels
      dataLabels: {
        enabled: true,
        formatter: (value, { seriesIndex, w }) => {
          return w.config.series[seriesIndex];
        },
      },
      tooltip: {
        y: {
          formatter: (value) => `${value} Incidents`,
        },
      },
    },
  });

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      const series = data.map((item) => item.count);
      const labels = data.map((item) => item.type);
      const colors = data.map(
        (item) => categoryColors[item.type.toLowerCase()] || 'rgb(200,200,200)'
      );

      setChartData((prev) => ({
        ...prev,
        series,
        options: {
          ...prev.options,
          labels,
          colors,
        },
      }));
    }
  }, [data]);

  if (!data || data.length === 0) {
    return (
      <div
        style={{ height: height, width: width }}
        className='d-flex justify-content-center align-items-center text-center'
      >
        No data available, Please select exam day/shift filters to see past exam
        days data.
      </div>
    );
  }

  return (
    <div className='d-flex justify-content-center align-items-center'>
      {isLoading ? (
        <Loader />
      ) : (
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type='donut'
          height={height}
          width={width}
        />
      )}
      {showIncidentDetailsModal.show && (
        <IncidentListingModal
          showIncidentDetailsModal={showIncidentDetailsModal}
          setShowIncidentDetailsModal={setShowIncidentDetailsModal}
          incidents={modalData}
          selectedStage={selectedType}
        />
      )}
    </div>
  );
};

export default MinistryTypeOfIssueDonut;
